"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reply352WhoReply = void 0;
var tslib_1 = require("tslib");
var Message_1 = require("../../Message");
var MessageDefinition_1 = require("../../MessageDefinition");
var WhoQuery_1 = require("../Commands/WhoQuery");
var Reply352WhoReply = /** @class */ (function (_super) {
    tslib_1.__extends(Reply352WhoReply, _super);
    function Reply352WhoReply() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Reply352WhoReply.prototype, "isAway", {
        /**
         * Checks whether the found user is /away.
         */
        get: function () {
            return this.params.flags.includes('G');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reply352WhoReply.prototype, "isOper", {
        /**
         * Checks whether the found user is an IRCOp.
         */
        get: function () {
            return this.params.flags.includes('*');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reply352WhoReply.prototype, "isBot", {
        /**
         * Checks whether the found user is a bot.
         */
        get: function () {
            return this.params.flags.includes('B');
        },
        enumerable: false,
        configurable: true
    });
    Reply352WhoReply.prototype.isResponseTo = function (originalMessage) {
        return originalMessage instanceof WhoQuery_1.WhoQuery;
    };
    tslib_1.__decorate([
        MessageDefinition_1.MessageParamDefinition()
    ], Reply352WhoReply.prototype, "me", void 0);
    tslib_1.__decorate([
        MessageDefinition_1.MessageParamDefinition()
    ], Reply352WhoReply.prototype, "channel", void 0);
    tslib_1.__decorate([
        MessageDefinition_1.MessageParamDefinition()
    ], Reply352WhoReply.prototype, "user", void 0);
    tslib_1.__decorate([
        MessageDefinition_1.MessageParamDefinition()
    ], Reply352WhoReply.prototype, "host", void 0);
    tslib_1.__decorate([
        MessageDefinition_1.MessageParamDefinition()
    ], Reply352WhoReply.prototype, "server", void 0);
    tslib_1.__decorate([
        MessageDefinition_1.MessageParamDefinition()
    ], Reply352WhoReply.prototype, "nick", void 0);
    tslib_1.__decorate([
        MessageDefinition_1.MessageParamDefinition()
    ], Reply352WhoReply.prototype, "flags", void 0);
    tslib_1.__decorate([
        MessageDefinition_1.MessageParamDefinition({
            trailing: true
        })
    ], Reply352WhoReply.prototype, "hopsAndRealName", void 0);
    Reply352WhoReply = tslib_1.__decorate([
        MessageDefinition_1.MessageType('352')
    ], Reply352WhoReply);
    return Reply352WhoReply;
}(Message_1.Message));
exports.Reply352WhoReply = Reply352WhoReply;
